import React from "react";
import { useEffect, useState } from "react";
import { ValidatorContainer, ValidationItem, Icon } from "../../components/GeneralStyles/GeneralStyles";
import Valid from "./Assets/Valid.svg";
import Unchecked from "./Assets/Unchecked.svg";

const PasswordValidator = ({
  password,
  setInvalidPassword
}: any) => {
  const [iconSrc, setIconSrc] = useState(Unchecked);

  // booleans for password validations
  const [contains8C, setContains8C] = useState(false); // min 8 characters
  const [containsUL, setContainsUL] = useState(false); // uppercase letter
  const [containsLL, setContainsLL] = useState(false); // lowercase letter
  const [containsSC, setContainsSC] = useState(false); // special character
  const [containsN, setContainsN] = useState(false); // number
  const [allValid, setAllValid] = useState(false);

  // labels and state boolean corresponding to each validation
  const mustContainData = [
    ["8 Characters", contains8C],
    ["1 Uppercase letter", containsUL],
    ["Lowercase letter", containsLL],
    ["Special character", containsSC],
    ["Number", containsN],
  ];

  const validatePassword = () => {
    // has uppercase letter
    if (password.toLowerCase() !== password) setContainsUL(true);
    else setContainsUL(false);

    // has lowercase letter
    if (password.toUpperCase() !== password) {
      setContainsLL(true);
    } else {
      setContainsLL(false);
    }

    // has number
    if (/\d/.test(password)) setContainsN(true);
    else setContainsN(false);

    // has special character
    if (/[~`!#@$ֿ()%^&*+=\-[\]\\';,/{}|\\":<>?]/g.test(password)) setContainsSC(true);
    else setContainsSC(false);

    // has 8 characters
    if (password.length >= 8) setContains8C(true);
    else setContains8C(false);

    // all validations passed
    // if (containsUL && containsLL && containsN && containsSC && contains8C) setInvalidPassword(false);
    if (containsUL && containsLL && containsN && containsSC && contains8C) {
      setAllValid(true);
    }
  };

  useEffect(() => {
    validatePassword();
  }, [password]);

  return (
    <ValidatorContainer>
      Use at least:
      {mustContainData.slice(0, 5).map((item, index) => {
        return (
          <ValidationItem key={index}>
            <Icon src={item[1] ? Valid : iconSrc} alt="checkmark" marginRight="3px" marginLeft="2px" />
            {item}
          </ValidationItem>
        );
      })}
    </ValidatorContainer>
  );
};

export default PasswordValidator;
